import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const Bird = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="#FFFFFF"
        height="800px"
        width="800px"
        version="1.1"
        id="Layer_1"
        viewBox="0 0 457.825 457.825"
      >
        <g>
          <g>
            <g>
              <path d="M259.605,246.305c5.277-0.792,9.281-4.873,10.116-9.97c13.445-82.06,70.751-154.119,155.08-182.37l0.093-0.031     c3.713-1.242,6.69-4.174,7.755-7.942c1.957-6.924-2.245-13.534-8.689-15.096c-26.845-6.51-55.786-5.783-83.913,3.64     c-52.79,17.685-89.435,61.543-100.334,112.297c-0.72,3.351-2.599,6.419-5.517,8.217c-4.612,2.841-10.345,2.25-14.257-1.153     c-39.294-34.182-95.146-47.249-148.1-29.509c-27.99,9.377-51.437,26.113-68.915,47.333c-3.162,3.839-3.9,9.256-1.52,13.623     c2.817,5.168,8.882,7.491,14.345,5.656c0.048-0.016,0.096-0.032,0.145-0.048c84.199-28.207,173.203-5.327,233.364,51.877     C252.028,245.463,255.825,246.872,259.605,246.305z" />
              <path d="M453.211,307.392c-18.598-10.981-40.412-17.026-63.596-16.381c-43.652,1.214-81.147,25.829-100.804,61.495     c-1.61,2.921-4.646,4.772-7.981,4.864c-3.334,0.091-6.461-1.593-8.231-4.42c-21.61-34.514-60.412-57.004-104.061-55.79     c-23.184,0.645-44.628,7.893-62.587,19.89c-3.473,2.32-4.991,6.657-3.724,10.637c1.267,3.979,5.015,6.648,9.19,6.53     c0.04-0.001,0.079-0.002,0.119-0.003c69.511-1.933,130.96,35.564,162.896,92.196c1.713,3.038,4.966,4.879,8.453,4.784     c3.486-0.095,6.638-2.11,8.179-5.239c28.737-58.324,88.01-99.181,157.524-101.115c0.04-0.001,0.079-0.002,0.119-0.003     c4.178-0.113,7.775-2.979,8.82-7.026C458.572,313.764,456.81,309.517,453.211,307.392z" />
            </g>
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
};
